import React from "react";
import cx from "classnames";
import styles from "./InputFeedback.module.scss";

import { TFormikError } from "components/shared/ui/form-elements/FormikElements";

const InputFeedback = ({
  error,
  visible,
  classNames
}: {
  error?: TFormikError;
  visible?: boolean;
  classNames?: string;
}) => (
  <div
    className={cx(styles.inputFeedback, visible && styles.visible, classNames)}
  >
    {error}
  </div>
);

export default InputFeedback;
